// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { FeatureChoice } from './feature-choice';
import { StagedProductColor } from './staged-product-color';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class StagedProductPart extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(50) */
  apparelStyle?: string;
  /** String(50) */
  customSize?: string;
  /** Decimal */
  depthAmt?: number;
  /** String(20) */
  dimensionUom?: string;
  /** DateTimeOffset */
  effectiveDate?: Date;
  /** DateTimeOffset */
  endDate?: Date;
  /** Int32 FK featureChoice */
  featureChoiceId?: number;
  /** String(50) */
  gtin?: string;
  /** Decimal */
  heightAmt?: number;
  /** Boolean */
  isCaution!: boolean;
  /** Boolean */
  isCloseout!: boolean;
  /** Boolean */
  isFeatureChoiceManual!: boolean;
  /** Boolean */
  isHazmat!: boolean;
  /** Boolean */
  isOnDemand!: boolean;
  /** Boolean */
  isRushService!: boolean;
  /** String(50) */
  labelSize?: string;
  /** String(50) */
  partId!: string;
  /** DateTimeOffset */
  snapshotTs!: Date;
  /** Int32 FK stagedProductColor */
  stagedProductColorId!: number;
  /** Decimal */
  weightAmt?: number;
  /** String(20) */
  weightUom?: string;
  /** Decimal */
  widthAmt?: number;
  /** FK featureChoiceId */
  featureChoice!: FeatureChoice;
  /** FK stagedProductColorId */
  stagedProductColor!: StagedProductColor;
}

